import script from "./detalhes-contato.vue?vue&type=script&setup=true&lang=js"
export * from "./detalhes-contato.vue?vue&type=script&setup=true&lang=js"

import "./detalhes-contato.vue?vue&type=style&index=0&id=1bd088a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bd088a5"]])

export default __exports__